import './Activity.scss';
import { Col } from 'reactstrap';
import ActivityList from './ActivityList';
import Companies from './Companies';
import Contacts from './Contacts';
import Projects from './Projects';

export interface IActivityTabProps {
    dealId: number;
    orgId: string;
}

const Activity = ({
    dealId, orgId,
}: IActivityTabProps) => (
    <div className="DealActivity">
        <div className="d-flex">
            <Col md="9" className="">
                <ActivityList
                    dealId={dealId}
                    organizationId={orgId}
                />
            </Col>

            <Col md="3" className="DealActivity__sidebar p-0">
                <Companies
                    organizationId={orgId}
                    dealId={dealId}
                />
                <Contacts
                    organizationId={orgId}
                    dealId={dealId}
                />
                <Projects
                    organizationId={orgId}
                    dealId={dealId}
                />
            </Col>
        </div>
    </div>
);

export default Activity;
